export default {
    container: {
        flex: 1,
        flexDirection: 'row'
    }
};
